import React, { useEffect } from 'react';
import { loadAllFonts, loadSpecificFonts } from '../../utils/remotion/fontLoader';

interface FontLoaderProps {
  /** Array of specific font names to load. If not provided, all fonts will be loaded */
  fontNames?: string[];
  /** Whether to load fonts immediately when component mounts */
  immediate?: boolean;
}

/**
 * FontLoader component that handles loading fonts for Remotion compositions
 * Place this component at the root of your composition or early in the component tree
 */
export const FontLoader: React.FC<FontLoaderProps> = ({ 
  fontNames, 
  immediate = true 
}) => {
  useEffect(() => {
    if (!immediate) return;

    const loadFonts = async () => {
      try {
        if (fontNames && fontNames.length > 0) {
          await loadSpecificFonts(fontNames);
        } else {
          await loadAllFonts();
        }
      } catch (error) {
        console.error('FontLoader: Error loading fonts:', error);
      }
    };

    loadFonts();
  }, [fontNames, immediate]);

  // This component doesn't render anything visible
  return null;
};

export default FontLoader; 